import { render, staticRenderFns } from "./yeni.vue?vue&type=template&id=247018f5&"
import script from "./yeni.vue?vue&type=script&lang=js&"
export * from "./yeni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports